import { message, Modal } from 'antd'
import { TrackingApi } from '../../../../api/Tracking'
import AddPackageForm from '../../../../components/Main/Tracking/AddPackages/AddPackageForm'
import { pick, get } from 'lodash'
import { checkForm } from '../../../../modules/Utils'
import React, { useState } from 'react'

function AddPackages(props) {
  const { fetching, visible, onCancel, tracking, fetch } = props
  const [pkgInfo, setPkgInfo] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const formRef = React.createRef()

  console.log({ pkgInfo })

  async function submit() {
    const newObject = await checkForm(formRef)
    let newPackages = [...get(tracking, 'packages', []), { ...pkgInfo, ...newObject }]
    await _update(newPackages)
  }

  async function remove() {
    const newObject = await checkForm(formRef)
    let newPackages = get(tracking, 'packages', []).filter(p => p._id !== newObject._id)
    await _update(newPackages)
  }

  async function update() {
    const newObject = await checkForm(formRef)
    let newPackages = get(tracking, 'packages', []).filter(p => p._id !== newObject._id)
    newPackages = [...newPackages, { ...pkgInfo, ...newObject }]
    await _update(newPackages)
  }

  async function _update(list) {
    setSubmitting(true)
    try {
      console.log({ list })
      await TrackingApi.update({
        ...pick(tracking, ['_id', '_key', '_rev']),
        ...{ packages: list },
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <>
      <Modal
        title="Packages"
        visible={visible}
        onCancel={onCancel}
        destroyOnClose={true}
        confirmLoading={fetching}
        width={'60%'}
        footer={null}>
        <AddPackageForm
          {...{ ...props, setPkgInfo, submit, remove, update, submitting }}
          ref={formRef}
        />
      </Modal>
    </>
  )
}

export default AddPackages
